import React from "react";
import PropTypes from "prop-types";
import { cnb } from "cnbuilder";
import { ReactComponent as ArrowLeft } from "../../../styles/default/assets/icons/ic_pulse_arrow_left_default.svg";
import { ReactComponent as ThumbsUp } from "../../../styles/default/assets/icons/ic_pulse_thumbs_up.svg";
import { ReactComponent as ThumbsDown } from "../../../styles/default/assets/icons/ic_pulse_thumbs_down.svg";
import { ReactComponent as HeartIcon } from "../../../styles/default/assets/icons/ic_pulse_blood_pressure_default.svg";
import { ReactComponent as PlusIcon } from "../../../styles/default/assets/icons/ic_pulse_plus_default.svg";

/**
 * IconComponent added to have posibility to change "fill" colors
 * for different states (hover, active, disabled)
 *
 * To get proper Icon you need to:
 *  - download new icon to assets
 *  - import ReactComponent as YourNewIcon from assets
 *  - add new case to IconComponent for YourNewIcon
 *  - add custom styles for your case (if needed)
 *
 */

const IconComponent = ({ icon, ...attrs }) => {
  switch (icon) {
    case "ic_pulse_arrow_left_default":
      return <ArrowLeft {...attrs} />;
    case "ic_pulse_thumbs_up":
      return <ThumbsUp {...attrs} />;
    case "ic_pulse_thumbs_down":
      return <ThumbsDown {...attrs} />;
    case "ic_pulse_blood_pressure_default":
      return <HeartIcon {...attrs} />;
    default:
      return <PlusIcon {...attrs} />;
  }
};

const ModernizedIconButton = ({
  className,
  disabled = false,
  icon = "default",
  onClick,
  size = "md",
  testAttr = "modernized-icon-button",
  type = "default",
  ...attrs
}) => (
  <button
    type='button'
    className={cnb(
      "modernized-icon-button-web-sdk",
      `type-${type}`,
      `icon-button-${size}`,
      `icon-${icon}`,
      className
    )}
    data-testid={testAttr}
    disabled={disabled}
    onClick={onClick}
    {...attrs}
  >
    <IconComponent icon={icon} className='button-icon' aria-hidden='true' />
  </button>
);

IconComponent.propTypes = {
  icon: PropTypes.string.isRequired
};

ModernizedIconButton.propTypes = {
  className: PropTypes.string,
  disabled: PropTypes.bool,
  icon: PropTypes.string,
  onClick: PropTypes.func,
  size: PropTypes.oneOf(["sm", "md"]),
  testAttr: PropTypes.string,
  type: PropTypes.oneOf(["default", "subtle"])
};

export default ModernizedIconButton;
